import React from "react";
import { HelmetProvider } from "react-helmet-async";
import ReactDOM from "react-dom/client";
import "./index.less";
import { GlobalProvider } from "./contexts";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.less";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <GlobalProvider>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </GlobalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
